module.exports = __webpack_public_path__ + "img/94.88fbb678.jpg";